import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'xp-shell',
	standalone: true,
	templateUrl: './xp-shell.component.html',
	styleUrls: ['./xp-shell.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class XpShellComponent { }
